const activitycomment = {
    add: 'activitycomment/add-by-admin',
    getlist: 'activitycomment/getlist-by-admin',
    update: 'activitycomment/update',
    remove: 'activitycomment/remove',
    get: 'activitycomment/get',
}
export default activitycomment
